// removed by extract-text-webpack-plugin
module.exports = {"auditTemplateDetailHeader":"AuditTemplateDetailHeader__auditTemplateDetailHeader__3B12H","backToOverview":"AuditTemplateDetailHeader__backToOverview__2kbQD","icon":"AuditTemplateDetailHeader__icon__MpbjO"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/AuditTemplateDetailView/AuditTemplateDetailHeader/AuditTemplateDetailHeader.scss
// module id = 1745
// module chunks = 0